export default "__VITE_ASSET__URUVEEEh__"